let projectContent = [
	{
		name: "Flashcard Application",
		desc:
			"Full Stack application used to create and study flashcards.  The webapp is designed to run alongside a basic Express Rest Server that handles the API calls to the database to retrieve cards stored under an authenticated user.",
		tech: "ReactJS, NextJS, MongoDB, Firebase Auth, MaterialUI",
		link: "https://github.com/briankeefe/webApp"
	},
	{
		name: "Snowday Calculator",
		desc:
			"Basic Frontend Webapp that takes in a zip code, makes an API call to a weather service to determine the weather and projected snowfall, then outputs the predicted forecast along with a crude estimate of the chance of a snowday",
		tech: "ReactJS, Create-React-App, Material-UI",
		link: "http://github.com/briankeefe/Snowday"
	},
	{
		name: "Static Restaurant Menu Generator",
		desc:
			"Takes in a json of menu items and generates a MaterialUI themed page.  Example shown in link",
		tech: "React",
		link: "http://briankeefe.github.io/#/Willikers"
	}
];

export default projectContent;
